var i = /* @__PURE__ */ ((e) => (e.medium = "medium", e.large = "large", e))(i || {});
function l(e) {
  const s = ["slider"];
  switch (e.size) {
    case "large":
      s.push("slider-lg");
      break;
    default:
    case "medium":
      s.push("slider-md");
      break;
  }
  return e.disabled && s.push("slider-disabled"), s.join(" ");
}
function r(e) {
  const s = ["slider-input"];
  switch (e) {
    case "large":
      s.push("slider-input-lg");
      break;
    default:
    case "medium":
      s.push("slider-input-md");
      break;
  }
  return s.join(" ");
}
export {
  i as SliderSize,
  r as getSliderInputSizeClasses,
  l as getSliderStyleClasses
};
